import { ChangeEvent, FC, useState } from 'react';
import Slider from '@mui/material/Slider';
import classnames from 'classnames';
import { useTranslationContext } from '../../contexts/translationContext';
import styles from './durationSlider.module.scss';

interface DurationSliderProps {
    duration: number;
    setDuration: (duration: number) => void;
}

const DurationSlider: FC<DurationSliderProps> = ({ duration, setDuration }: DurationSliderProps) => {
    const [isActive, setIsActive] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const minTime = 0;
    const maxTime = 60;
    const { translate } = useTranslationContext();

    const handleSliderChange = (_event: Event, newValue: number | number[]) => {
        setDuration(newValue as number);
    };

    const handleInputChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newValue = Number((event.target as HTMLInputElement).value);
        if (!isNaN(newValue) && newValue >= minTime && newValue <= maxTime) {
            setDuration(newValue);
        }
    };

    return (
        <div className={styles['slider-wrapper']}>
            <div className={styles.slider}>
                <Slider
                    onChange={handleSliderChange}
                    onFocus={() => setIsActive(true)}
                    onBlur={() => setIsActive(false)}
                    defaultValue={duration}
                    value={duration}
                    min={minTime}
                    max={maxTime}
                    component="span"
                />
            </div>
            <div
                className={classnames(
                    styles['duration-container'],
                    isActive && styles['duration-container-active'],
                    isClicked && styles['duration-container-clicked']
                )}
            >
                <input
                    className={classnames(
                        styles['duration-input'],
                        isClicked && styles['duration-input-clicked'],
                        isActive && styles['duration-input-active']
                    )}
                    value={duration}
                    onChange={handleInputChange}
                    onClick={() => setIsClicked(true)}
                    onBlur={() => setIsClicked(false)}
                />
                <span
                    className={classnames(
                        styles['duration-text'],
                        isActive && styles['duration-text-active'],
                        isClicked && styles['duration-text-clicked']
                    )}
                >
                    {translate('mins')}
                </span>
            </div>
        </div>
    );
};

export default DurationSlider;
